import { intlLocale } from "./languages";
import { activeDictionary, activeLanguage, englishDictionary } from "./store";
import { translate } from "./translate";
import type { Params, PlainKey, PluralKey } from "./types";

/**
 * G-85 — `t` for code that is not a React component.
 *
 * Reads the store at CALL time. The house rule that follows: never call `t()`
 * at module top level (`const MSG = t("…")`) — the store is "en" until the
 * kiosk mounts, and a constant computed then stays English for the whole
 * session. Compute the text where it is thrown or rendered.
 *
 * Components use `useT()` from `LanguageProvider.tsx` instead, which is this
 * same function wrapped in a subscription so they repaint on a switch.
 */
export function t<K extends PluralKey>(
  key: K,
  params: Params & { count: number },
): string;
export function t<K extends PlainKey>(key: K, params?: Params): string;
export function t(key: string, params?: Params): string {
  return translate(
    activeDictionary(),
    englishDictionary(),
    intlLocale(activeLanguage()),
    key,
    params,
  );
}

export type TranslateFn = typeof t;
